"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var index_1 = __importDefault(require("../Icon/index"));

var CheckBox_1 = __importDefault(require("../Input/CheckBox")); // tslint:disable: max-line-length


var item = function item(_a) {
  var label = _a.label,
      id = _a.id,
      alwaysShow = _a.alwaysShow,
      onItemCheckClick = _a.onItemCheckClick,
      checked = _a.checked,
      icon = _a.icon,
      innerRef = _a.innerRef,
      dragHandleProps = _a.dragHandleProps,
      draggableProps = _a.draggableProps;
  return react_1.default.createElement("div", __assign({
    className: "modal_item",
    ref: innerRef
  }, draggableProps), react_1.default.createElement("div", {
    className: "modal_item_content"
  }, alwaysShow ? undefined : react_1.default.createElement(CheckBox_1.default, {
    value: checked,
    onChange: onItemCheckClick,
    className: "modal_item_checkbox"
  }), react_1.default.createElement("span", {
    className: "modal_item_text " + (alwaysShow ? 'with_margin' : undefined),
    onClick: alwaysShow ? undefined : onItemCheckClick
  }, label || id)), react_1.default.createElement("div", __assign({
    className: checked ? 'modal_item_icon' : 'modal_item_icon_hide'
  }, dragHandleProps), react_1.default.createElement(index_1.default, {
    icon: icon,
    width: 18,
    height: 20
  })));
};

exports.default = item;